import {useContext} from 'react';
import SizeMastersContext from './size-masters-context';

const useSizeMasters = () => {
  const context = useContext(SizeMastersContext);
  return context
};

export default useSizeMasters;
